
import {
    AppMainContainer,
    AppSubContainer,
} from "../../../../Libraries";
import useGetSellerProducts from "../../../../hooks/useGetSellerProducts";
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import useGetCategories from "../../../../hooks/useGetCategories";
import BusinessLoader from "../../../common/BusinessLoader";
import fourOFour from "../../../../assets/images/404.webp";
import { setCurrentScreen } from "firebase/analytics";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import {
    AppNonIdeal
} from "../../../common";
import { handleApi } from "../../../../apis";
import CreateStock from "../../../container/StockManagementFlow/CreateStock";
import { GET_SELLER_PRODUCTS } from "../../../../apis/configuration";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const CreateStockWrapper = () => {
    const location = useLocation();
    const params = useParams();
    const stockId = params?.id;
    let isSeller = localStorage.getItem("is_marketplace_seller");
    const navigate = useNavigate();

    const { handleGetProducts } =
        useGetSellerProducts(isSeller) || {};
    const { getCategories, catLoading, categories } = useGetCategories();
    const [I18n] = useContext(LanguageContext);
    const [details, setDetails] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const isReadOnly = location.pathname?.toLowerCase().includes("/saddarinventory/stockdetail"); 
    
    useEffect(() => {
        if (stockId)
            handleStockDetails(stockId)
    }, [stockId])

    const handleStockDetails = async (id) => {
        try {
            setLoading(true);
            let { results } = await handleApi(GET_SELLER_PRODUCTS, {
                product_id: id,
            },null,navigate);
            if (results?.length) setDetails(results[0]);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
            navigate("/SaddarInventory", { replace: true })
        }
        finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getCategories().catch(() => {}); // hook already shows the error toast
        setCurrentScreen(analytics, "CreateStock_screen");
    }, []);



    /**
     * Open create stock page by params (toggle) and get categories if not exist
     * @returns true or false
     */
    const handleCreateEditStock = async (toggle = false) => {
        // if (!Object.keys(categories).length) await getCategories();
        // setCreate(toggle);
    };

    /**
     * Receive params for create, edit, publish and delect stock.
     * Referesh key to updtae the detail stock page
     * @returns updated stock or updated stock list
     */
    const handleStock = (endpoint, params, refresh) => {
        return new Promise(async (resolve, reject) => {
            try {
                let stock = await handleApi(endpoint, params,null,navigate);
                await handleGetProducts();
                refresh && setDetails(stock.updated_data);
                resolve();
            } catch (err) {
                reject(err);
            }
        });
    };



    return isSeller ? (
        (!isLoading && !catLoading) ?
            <CreateStock
                data={{
                    handleClose: () => {
                        navigate("/SaddarInventory", { replace: true })
                    },
                    stock: details,
                    handleStock,
                    categories,
                    I18n,
                    isReadOnly
                }}
            /> : <BusinessLoader loadBusiness={isLoading || catLoading} />
    ) : (
        <AppMainContainer>
            <AppSubContainer>
                <AppNonIdeal
                    data={{
                        title: I18n.page_not_found,
                        subtitle: I18n.we_re_sorry_the_page_you_requested,
                        image: fourOFour,
                        I18n,
                    }}
                />
            </AppSubContainer>
        </AppMainContainer>
    );
};



export default CreateStockWrapper;
